// src/admin/utils/translateError.ts — map Postgres error codes + known messages to human text.
import type { PostgrestError } from '@supabase/supabase-js';

export function translateError(err: PostgrestError | Error | null | undefined): string {
  if (!err) return 'Unknown error';
  const code = (err as PostgrestError).code;
  const msg = err.message ?? '';

  switch (code) {
    case '42501': return "You don't have permission to do that.";
    case '23505': return 'That record already exists.';
    case '23503': return 'Related record is missing — refresh and try again.';
    case 'PGRST116': return 'Record not found.';
    case 'PGRST301': return 'Your session expired. Sign in again.';
    case 'PGRST302': return "You don't have permission to read this.";
  }

  // Trigger-raised human-readable messages bubble through as-is
  if (/append-only/i.test(msg)) return 'This record cannot be edited once created.';
  if (/invalid transition/i.test(msg)) return 'That status change is not allowed.';
  if (/review_fields_consistent/i.test(msg)) return 'Review fields are inconsistent.';
  if (/ptp_fields_consistent/i.test(msg)) return 'Promise-to-pay needs both amount and date.';
  if (/target_exactly_one/i.test(msg)) return 'Request must target exactly one of loan, borrower, or payment.';

  return msg || 'Something went wrong.';
}
